var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.currentModal
      ? _c(
          "div",
          {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.closeModal,
                expression: "closeModal"
              }
            ]
          },
          [
            _c(
              "div",
              { staticClass: "modal-container", style: { height: _vm.height } },
              [
                _c("div", { staticClass: "modal-heading" }, [
                  _vm.showCloseButton
                    ? _c(
                        "div",
                        {
                          staticClass: "invisible-btn",
                          on: { click: _vm.closeModal }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/img/svg/down.svg")
                            }
                          })
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "keep-alive",
                  [
                    _c(_vm.currentModal, {
                      ref: "currentModal",
                      tag: "component",
                      on: {
                        removeModal: function($event) {
                          return _vm.removeModal($event)
                        },
                        submit: _vm.closeModal
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1962e4b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1962e4b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/Modal.vue
// module id = null
// module chunks = 